import { initReactI18next } from 'react-i18next';
import i18next from 'i18next';
import Backend from 'i18next-http-backend';
// Languages files
import translationEn from './en.json';

const resources = {
	en: {
		translation: translationEn,
	},
};
i18next
	.use(Backend)
	.use(initReactI18next)
	.init({
		lng: 'en',
		fallbackLng: 'en',
		resources,
		react: { useSuspense: true }, //this line
		interpolation: {
			escapeValue: false,
		},
	});

export default i18next;
